//      
import React from 'react';
import checkReactVersion from './check-react-version';
import checkDoctype from './check-doctype';
import useDevSetupWarning from '../use-dev-setup-warning';

export default function useStartupValidation() {
  useDevSetupWarning(() => {
    checkDoctype(document);
  }, []);
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/drag-drop-context/use-startup-validation.js